import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Hero } from '../components/Hero';
import { AlertCircle, Clock } from 'lucide-react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const HomePage = () => {
  const navigate = useNavigate();
  const [motosEsgotadas, setMotosEsgotadas] = useState(false);

  useEffect(() => {
    const checkAlertas = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/site/alertas`);
        setMotosEsgotadas(res.data?.motos_esgotadas || false);
      } catch {
        setMotosEsgotadas(false);
      }
    };
    checkAlertas();
  }, []);

  return (
    <>
      {motosEsgotadas && (
        <div 
          onClick={() => navigate('/fila-espera')}
          className="bg-red-600 text-white py-4 px-4 cursor-pointer hover:bg-red-700 transition-colors"
          data-testid="alerta-motos-esgotadas"
        >
          <div className="max-w-7xl mx-auto flex items-center justify-center gap-3 flex-wrap text-center">
            <AlertCircle className="w-6 h-6 animate-pulse" />
            <span className="font-bold text-lg md:text-xl">
              MOTOS ESGOTADAS
            </span>
            <span className="hidden md:inline">|</span>
            <span className="font-semibold text-base md:text-lg">
              Entre na Fila de Espera
            </span>
            <Clock className="w-5 h-5" />
          </div>
          <p className="text-center text-sm mt-1 opacity-90">
            Clique aqui para se cadastrar e ser avisado quando tivermos motos disponiveis
          </p>
        </div>
      )}
      <Hero />
    </>
  );
};
